import { styled } from '@withjoy/joykit';

export const FooterLink = styled.button`
  text-decoration: underline;
`;
